import React from 'react';
import { Navigate } from 'react-router';

import designationRoutes from '../components/CMS/Subscriber/MyDesignation/routes';
import myCECertificates from '../components/CMS/Subscriber/MyCECertificates/routes';
import myCertificatesOfCompletion from '../components/CMS/Subscriber/MyCertificatesOfCompletion/routes';
import myLearningRoutes from '../components/CMS/Subscriber/MyLeaning/routes';

import organizationDashboardRoutes from '../components/CMS/Organizations/Dashboard/Routes';
import organizationAdminUserRoutes from '../components/CMS/Organizations/AdminUsers/routes';
import organizationAccountSettingsRoutes from '../components/CMS/Organizations/AccountSettings/routes';
import organizationPurchasesRoutes from '../components/CMS/Organizations/Purchases/Routes';
import organizationCourseRoutes from '../components/CMS/Organizations/ManageSeats/routes';
import organizationTrainingRoutes from '../components/CMS/Organizations/TrainingGroups/routes';
import organizationMembersRoutes from '../components/CMS/Organizations/OrganizationMembers/routes';
import organizationUsersGroupsRoutes from '../components/CMS/Organizations/UsersGroups/routes';
import organizationReporting from '../components/CMS/Organizations/OrganizationReporting/routes';

// A route object has the same properties as a <Route>
// element. The `children` is just an array of child routes.

const subscriberRoutes = [
     myLearningRoutes,
     designationRoutes,
     myCECertificates,
     myCertificatesOfCompletion,
     {
          path: '*',
          element: <Navigate to="/my-learning" />,
     },
];

export const organizationRoutes = [
     organizationDashboardRoutes,
     organizationAdminUserRoutes,
     organizationAccountSettingsRoutes,
     organizationPurchasesRoutes,
     organizationTrainingRoutes,
     organizationCourseRoutes,
     organizationMembersRoutes,
     organizationUsersGroupsRoutes,
     organizationReporting,
];

export default subscriberRoutes;
